export class SaleOrderDepartureReason {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new SaleOrderDepartureReason(
      this.hash,
      this.name
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-departure-reason.ts